<template>
    <div>
        <dashboard-users-invite-modal
            v-if="showInviteModal"
            @close="closeModal"
        />
        <section class="section">
            <div class="level is-mobile">
                <div class="level-left">
                    <div class="level-item">
                        <p
                            v-t="'Dashboard.users'"
                            class="has-text-weight-bold is-size-5"
                        ></p>
                    </div>
                </div>
                <div class="level-right">
                    <div class="level-item">
                        <button
                            v-t="'add_user'"
                            class="button is-primary"
                            @click="showInviteModal = true"
                        />
                    </div>
                </div>
            </div>
            <div class="table-container">
                <table
                    class="table is-bordered is-fullwidth is-striped is-hoverable"
                >
                    <thead>
                        <tr class="has-cursor-pointer">
                            <th v-t="'User.name'" @click="sort('name')"></th>
                            <!--th 
                v-t="'User.username'" 
              @click="sort('username')"></th-->
                            <th v-t="'User.email'" @click="sort('email')"></th>
                            <th v-t="'User.role'" @click="sort('role')"></th>
                            <th v-t="'User.state'" @click="sort('state')"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(member, index) in sortedUsers" :key="index">
                            <td>{{ member.name }}</td>
                            <!--td>{{ member.username }}</td-->
                            <td>{{ member.email }}</td>
                            <td>
                                <div class="tags">
                                    <div
                                        v-for="role in member.roles"
                                        :key="role"
                                        :class="`lb-role-tag_${role}`"
                                    >
                                        {{
                                            $t(
                                                `Constants.ROLE_${role.toUpperCase()}`
                                            )
                                        }}
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span
                                    v-t="`Constants.STATUS_${member.status}`"
                                    :class="`lb-status-tag_${member.status.toLowerCase()}`"
                                ></span>
                                <div
                                    v-if="canManageSchool"
                                    class="is-pulled-right"
                                    @click.stop.prevent
                                >
                                    <div
                                        class="dropdown is-right is-hoverable is-pulled-right"
                                    >
                                        <span
                                            class="icon is-small dropdown-trigger has-text-grey mt-1"
                                        >
                                            <i
                                                class="mdi mdi-36px mdi-dots-vertical"
                                                aria-hidden="true"
                                            />
                                        </span>
                                        <div class="dropdown-menu" role="menu">
                                            <div class="dropdown-content">
                                                <div
                                                    class="dropdown-item"
                                                    @click="
                                                        leaveSchool(
                                                            member.owner
                                                        )
                                                    "
                                                >
                                                    <a
                                                        v-t="
                                                            'userProfile.leave_school'
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </section>
    </div>
</template>

<script>
import { fetchSchoolMembers, leaveSchool } from '@/services/API';
import DashboardUsersInviteModal from '@/components/DashboardUsersInviteModal';
import _ from 'underscore';
import Swal from 'sweetalert2';
export default {
    components: { DashboardUsersInviteModal },
    data() {
        return {
            users: [],
            showInviteModal: false,
            sortField: 'name',
            reverse: false,
        };
    },
    computed: {
        school() {
            return this.$store.getters.school;
        },
        sortedUsers() {
            let sorted = _.sortBy(this.users, this.sortField);
            return this.reverse ? sorted.reverse() : sorted;
        },
        canManageSchool() {
            return this.$store.getters.canManageSchool;
        },
    },
    watch: {
        school: {
            handler: 'fetchUsers',
            immediate: true,
        },
    },
    methods: {
        async fetchUsers() {
            this.users = [];
            if (this.$store.getters.school) {
                let response = await fetchSchoolMembers();
                this.users = response.data;
            }
        },
        closeModal() {
            this.showInviteModal = false;
            this.fetchUsers();
        },
        sort(field) {
            if (this.sortField == field) {
                this.reverse = !this.reverse;
            } else {
                this.reverse = false;
            }
            this.sortField = field;
        },
        leaveSchool(userId) {
            Swal.fire({
                title: this.$t('userProfile.leave_school_sure'),
                text: this.$t('userProfile.leave_school_content_created'),
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: this.$t('userProfile.leave_school_continue'),
                cancelButtonText: this.$t('userProfile.leave_school_cancel'),
            }).then((result) => {
                if (result.isConfirmed) {
                    this.leave(userId);
                }
            });
        },
        async leave(userId) {
            let error = false;
            await leaveSchool(userId)
                .catch((e) => {
                    Swal.fire({
                        title: this.$t('Error.' + e.status),
                        text: this.$t('Error.MY_' + e.data),
                        showCancelButton: false,
                        confirmButtonText: this.$t(
                            'userProfile.leave_school_cancel'
                        ),
                        confirmButtonColor: '#d33',
                    });
                    error = true;
                    return;
                })
                .finally(() => {
                    if (!error) {
                        this.fetchUsers();
                    }
                });
        },
    },
};
</script>

<style scoped></style>
